import React from "react";
import { Download, Eye } from "lucide-react";

const p2 = (n) => String(n).padStart(2, "0");
const fmt = (iso) => { if (!iso) return ""; const d = new Date(iso); return `${p2(d.getDate())}.${p2(d.getMonth() + 1)} ${p2(d.getHours())}:${p2(d.getMinutes())}`; };

export function StatementViewBadge({ p, v, donem }) {
  if (!p.ekstre_acik && !v) return null;
  if (!v) {
    return (
      <span data-testid={`statement-view-badge-${p.sicil_no}`} title={`${donem} ekstresini personel henüz görüntülemedi`}
        className="inline-flex items-center px-1.5 py-0.5 mr-1 rounded text-[10px] font-semibold bg-slate-100 text-slate-500 align-middle">
        Bakmadı
      </span>
    );
  }
  const tip = [`${donem} ekstresi`, v.view_at && `Görüntüledi: ${fmt(v.view_at)} (${v.view_count}×)`, v.pdf_at && `İndirdi: ${fmt(v.pdf_at)} (${v.pdf_count}×)`].filter(Boolean).join(" · ");
  return (
    <span data-testid={`statement-view-badge-${p.sicil_no}`} title={tip}
      className={`inline-flex items-center gap-1 px-1.5 py-0.5 mr-1 rounded text-[10px] font-semibold align-middle ${v.pdf_at ? "bg-indigo-100 text-indigo-700" : "bg-emerald-100 text-emerald-700"}`}>
      {v.view_at && <Eye size={10} />}
      {v.pdf_at && <Download size={10} />}
      {v.pdf_at ? "İndirdi" : "Görüntüledi"} {fmt(v.pdf_at || v.view_at).split(" ")[0]}
    </span>
  );
}
